"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import "./ask-bar.css";

/**
 * Ask Your Map entry point for the create flow, where surrounding copy and the
 * data intake make the action understandable. The typed prompt stays in-page
 * through `onSubmit` until data is available.
 */
export function AskBar({
  mapId,
  placeholder,
  onSubmit,
}: {
  mapId?: string;
  placeholder: string;
  /**
   * In-page handler (FAIL-458). When set, submitting calls this INSTEAD of
   * navigating to `/?prompt=` — the signed-in create surface already hosts the
   * editor, so the prompt seeds the NL bar in place rather than bouncing away.
   * Omit only for a deliberate map-specific deep link.
   */
  onSubmit?: (prompt: string) => void;
}) {
  const router = useRouter();
  const [value, setValue] = useState("");

  function go(prompt: string) {
    const q = prompt.trim();
    if (onSubmit) {
      if (q) onSubmit(q);
      return;
    }
    const params = new URLSearchParams();
    if (mapId) params.set("map", mapId);
    if (q) params.set("prompt", q);
    const qs = params.toString();
    router.push(qs ? `/?${qs}` : "/");
  }

  return (
    <div className="pz-askbar">
      <form
        className="pz-askbar__field"
        onSubmit={(e) => {
          e.preventDefault();
          go(value);
        }}
      >
        <svg className="pz-askbar__spark" viewBox="0 0 24 24" fill="none" aria-hidden>
          <path
            d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3Z"
            fill="currentColor"
          />
        </svg>
        <input
          className="pz-askbar__input"
          value={value}
          placeholder={placeholder}
          aria-label={placeholder}
          onChange={(e) => setValue(e.target.value)}
        />
        <button type="submit" className="pz-askbar__go" aria-label="Ask">
          <svg viewBox="0 0 24 24" fill="none" aria-hidden>
            <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </form>
    </div>
  );
}
